import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import map from 'lodash/map';

// import { Link } from 'react-router-dom';
import {
  Button,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

// import ProjectMembersForm from './membersForm';

import { addMemberSuccess, deleteMemberSuccess } from '../../actions';
import { Member } from '../../api'

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';



const mapStateToProps = state => ({});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ addMemberSuccess, deleteMemberSuccess }, dispatch)
};


class ProjectMember extends Component {
  
  constructor(props) {
    super(props);
    this.deleteMember = this.deleteMember.bind(this)
    
    this.state = {
      isDeleting: false,
    };
  }
  
  async deleteMember(e) {
    if (e && e.preventDefault)
      e.preventDefault();
    const { member, deleteMemberSuccess } = this.props;
    
    if (!window.confirm(`Are you sure you want to remove ${member.email} from team?!`)){
      return;
    }
    
    const stopLoading = () => this.setState({isDeleting:false});
    
    this.setState({isDeleting:true});
    // Member.destroy({id: member.id}).then(deleteMemberSuccess).then(stopLoading, stopLoading);
    try {
      const res = await Member.destroy({id: member.id});
      stopLoading();
      deleteMemberSuccess(res);
    }
    catch (error) {
      stopLoading();
    }
  }
  
  render() {
    const { member } = this.props;
    return <ListGroupItem className="with-remove">
      <Button
        outline
        color="link"
        title="Remove"
        className="remove-button float-right"
        onClick={this.deleteMember}>
          <FA icon={faTrashAlt} />
      </Button>
      
      {member.email}
    </ListGroupItem>
  }
}

class ProjectMembers extends Component {
  
  render() {
    const { project, deleteMemberSuccess } = this.props;
    
    return (project ? <ListGroup className="mb-4">{map(project.members, (member, idx) => (
      <ProjectMember key={idx} member={member} deleteMemberSuccess={deleteMemberSuccess} />
      ))}</ListGroup>
    : null);
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(ProjectMembers);


// WEBPACK FOOTER //
// ./src/components/Projects/members.js